import React, { Component } from 'react';
import { isMatchesEmail, isValidEmail, handleFormErrors } from '../helpers/Fields';
import * as Config from '../config/Config';
import * as Common from '../helpers/Common';
import * as User from '../helpers/User';
const $ = window.$;
export default class HomeHeader extends Component {
	userLogin() {
		var authUser = this.refs.authuser.value;
		var authPwd = this.refs.authpwd.value;
		if (authUser.trim() == "" || authPwd.trim() == "") {
			handleFormErrors({
				'authpwd': "Please enter your username and password"
			});
			//Common.message("Validation error occurred.", "Please enter your username and password", "error");
		} else {
			handleFormErrors({});
			Common.reactLoader("show", "Please wait...");
			if (isMatchesEmail(authUser)) {
				fetch(Config.domainUrl + "user/login", {
					method: "POST",
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						authuser: authUser,
						authpwd: authPwd
					})
				}).then((response) => response.json()).then((responseJson) => {
					Common.reactLoader("hide");
					if (responseJson.status == 0) {
						Common.message(responseJson.message, responseJson.errors, "error");
					} else {
						try {
							Common.setTokenData("token", responseJson.token);
							Common.setUserData("isLoggedIn", true);
							let date = new Date();
							date.setSeconds(date.getSeconds() + Config.sessExpire);
							Common.setUserData("sessMax", date.getTime());
							let decodeJson = Common.parseJwt(responseJson.token);
							setTimeout(() => {
								if (decodeJson.beforeRoutes.length > 0) {
									this.props.redirect(decodeJson.beforeRoutes[0].url);
								} else if (decodeJson.afterRoutes.length > 0) {
									this.props.redirect(decodeJson.afterRoutes[0].url);
								} else {
									this.props.redirect(decodeJson.routePath);
								}
							}, 500);
						}
						catch (e) {
							alert('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.');
							this.props.router.goBack();
						}
					}
				});
			} else {
				fetch(Config.rootDomainUrl + "imeta/includes/metaajax_control.php?q=metalogin&name=" + authUser + "&pword=" + authPwd, {
					method: "GET",
				}).then((response) => response.json()).then((responseJson) => {
					Common.reactLoader("hide");
					if (responseJson == "Sucess") {
						window.location.href = Config.rootDomainUrl + "home.php";
					} else {
						Common.message("Validation error occurred.", "Username (or) password incorrect.", "error");
					}
				});
			}
		}
	}
	userForgotPassword() {
		var authEmail = this.refs.authemail.value;
		if (authEmail == "") {
			handleFormErrors({
				'authemail': "Please enter a valid E-mail address"
			});
			//Common.message("Validation error occurred.", "Please enter a valid E-mail address", "error");
		} else {
			handleFormErrors({});
			Common.reactLoader("show", "Please wait...");
			fetch(Config.domainUrl + "user/forgot-password", {
				method: "POST",
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					authemail: authEmail
				})
			}).then((response) => response.json()).then((responseJson) => {
				Common.reactLoader("hide");
				if (responseJson.status == 0) {
					Common.message(responseJson.message, responseJson.errors, "error");
				} else {
					this.refs.authemail.value = '';
					Common.message("", responseJson.message, "success");
				}
			});
		}
	}
	hide() {
		var div = document.getElementById("about-us-menu");
		div.style.display = "none";
		$('.about a:first').css('color', '#000000');
	}
	showhide() {
		var div = document.getElementById("about-us-menu");
		if (div.style.display !== "none") {
			div.style.display = "none";
			$('.about a:first').css('color', '#000000');
		} else {
			div.style.display = "block";
			$('.about a:first').css('color', '#ff0000');
		}
	}

	maskunmask(){
		if($('#password').attr('type') == 'password'){
			$("#password").attr('type','text');
			$(".eye_icon").removeClass('unmask');
		}else{
			$("#password").attr('type','password');
			
			$(".eye_icon").addClass('unmask');
		}
	}
	_handleKeyPress(e) {
		if (e.key === "Enter") {
			this.userLogin();
		}
	}

	_handleKeyEnterPress(e) {
		if (e.key === "Enter") {
			this.userForgotPassword();
		}
	}
	componentDidMount() {
		setTimeout(() => {
			// flexslider
			$('.flexslider').flexslider({
				animation: "slide",
				slideshowSpeed: 4500,
				animationDuration: 1200,
				directionNav: false
			});
			$('#toggle').click(function () {
				$('#menu').slideToggle();
			});
			$(".landing-page header").sticky({
				topSpacing: 0
			});
		}, 100);
	}
	render() {
		const appFullName = Config.appFullName;
		return (<div>
			{/* Header */}
			<header>
				{/* Header Top */}
				<section className="head-top">
					<div className="row">						
						<div className="logo">	<a href="#/learningroom" title={appFullName}>
							<img src={process.env.PUBLIC_URL + '/images/logo-361dm.png'} alt={appFullName} />
						</a></div>
						<div className="head-rgt">
							<nav id="main-menu">
								<div id="smoothmenu1" className="ddsmoothmenu">
									<ul>
										<li><a href={`${Config.onLineUrl}network/`}>Partners</a></li>
										<li><a href={`${Config.rootDomainUrl}institutions/`}>Institutions</a></li>
										<li><a href={`${Config.rootDomainUrl}corporates/`}>Corporates</a></li>
										<li><a href={`${Config.onLineUrl}`}>Individuals</a></li>
										<li><a href={`${Config.rootDomainUrl}asps/`}>ASPs</a></li>
										<li><a href={`${Config.rootDomainUrl}governments/`}>Governments</a></li>
										<li><a href={`${Config.rootDomainUrl}about-us/get-app-code.php`}>361DM App</a></li>
										<li><a href={`${Config.rootDomainUrl}about-us/careers.php`}>Careers</a></li>
									</ul>
								</div>
							</nav>
							<div className="head-rgt-icons">
								<div className="hd-phn"> <img src={process.env.PUBLIC_URL + '/images/phone-icon.png'} alt="" width="19" height="19" />+91 44 39361361</div>
								<div className="menu-ico"><a href="javascript:void(0);" id="toggle" className="open"> <img src={process.env.PUBLIC_URL + '/images/menu-icon.png'} alt="" width="19" height="13" /><span></span> MENU</a>
									<div id="menu" style={{ display: 'none' }}>
										<ul>
											<li><a href={`${Config.rootDomainUrl}our-science.php`} target="_blank" rel="noopener noreferrer" onMouseOver={e => this.hide()}>Our Science</a></li>
											<li><a href={`${Config.rootDomainUrl}our-technology.php`} target="_blank" rel="noopener noreferrer" onMouseOver={e => this.hide()}>Our technology</a></li>
											<li><a href={`${Config.onLineUrl}`} target="_blank" rel="noopener noreferrer" onMouseOver={e => this.hide()}>Our Products</a></li>
											{/*<li><a href="http://www.361dm.com/2016_361website/about-us/index.php#prettyPhoto" target="_blank" rel="noopener noreferrer">Our Team</a></li>*/}
											<li><a href={`${Config.rootDomainUrl}our-alliances.php`} target="_blank" rel="noopener noreferrer" onMouseOver={e => this.hide()}>Our Alliances</a></li>
											<li><a href={`${Config.rootDomainUrl}about-us/get-app-code.php`} target="_blank" rel="noopener noreferrer" onMouseOver={e => this.hide()}>361DM App</a></li>
											<li className="about"><a href="#" onClick={e => this.showhide()} onMouseOver={e => this.showhide()}>About Us</a>
												<ul id="about-us-menu" style={{ display: 'none' }}>
													<li><a href={`${Config.rootDomainUrl}about-us/company-profile.php`} target="_blank" rel="noopener noreferrer">Company profile</a></li>
													<li><a href={`${Config.rootDomainUrl}about-us/tech-platform.php`} target="_blank" rel="noopener noreferrer">Tech Platform</a></li>
													<li><a href={`${Config.rootDomainUrl}about-us/media-center.php`} target="_blank" rel="noopener noreferrer">Media Centre</a></li>
													<li><a href={`${Config.rootDomainUrl}about-us/students-corner.php`} target="_blank" rel="noopener noreferrer">Students Corner</a></li>
													<li><a href={`${Config.rootDomainUrl}about-us/alumni.php`} target="_blank" rel="noopener noreferrer">Alumni</a></li>
													<li><a href={`${Config.rootDomainUrl}about-us/careers.php`} target="_blank" rel="noopener noreferrer">Careers</a></li>
													<li><a href={`${Config.rootDomainUrl}about-us/contact-us.php`} target="_blank" rel="noopener noreferrer">Contact Us</a></li>
													<li><a href={`${Config.rootDomainUrl}about-us/privacy.php`} target="_blank" rel="noopener noreferrer">Privacy</a></li>
													<li><a href={`${Config.rootDomainUrl}about-us/terms.php`} target="_blank" rel="noopener noreferrer">Terms</a></li>
													<li><a href={`${Config.rootDomainUrl}about-us/legal.php`} target="_blank" rel="noopener noreferrer">Legal</a></li>
												</ul>
											</li>
											<li><a href={`${Config.rootDomainUrl}about-us/careers.php`} target="_blank" rel="noopener noreferrer" onMouseOver={e => this.hide()}>Careers</a></li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</header>
			{/* /Header */}
			{/* Banner */}
			<section className="banner">
				<div className="flexslider loading">
					<ul className="slides">
						<li><img src={process.env.PUBLIC_URL + '/images/dm_banner.jpg'} alt="" /></li>
						<li><img src={process.env.PUBLIC_URL + '/images/dm_banner2.jpg'} alt="" /></li>
						<li><img src={process.env.PUBLIC_URL + '/images/dm_banner3.jpg'} alt="" /></li>
					</ul>
				</div>
				{
					!User.isLoggedIn() &&
					<div className="login-section">
						<div className="row">
							<div className="learner-login">
								<div className="login-right" id="loginPanel">
									<h2>Learner <span>Login</span></h2>
									<div id="new_learner"> New learner? <a className="reg" title="Register PIN here" href="#/register">Register PIN here</a> </div>
									<div className="frm-outer">
										<div className="frm-control">
											<input type="text" maxLength="255" name="authuser" ref="authuser" placeholder="Username" onKeyPress={(e) => this._handleKeyPress(e)} />
											<label className="user-ico"></label>
										</div>
										<div className="frm-control" >
										
											<input type="password" id="password" maxLength="100" name="authpwd" ref="authpwd" placeholder="Password" onKeyPress={(e) => this._handleKeyPress(e)} />
											<label className="pwd-ico" ></label>
											<span className="eye_icon unmask" onClick={() => this.maskunmask()}></span>
										</div>
										<div id="active">
											<input type="button" name="submit" value="Login" title="Login" onClick={() => this.userLogin()} />
											&nbsp; <a href="javascript:void(0);" onClick={() => Common.showHide("#forgotPanel", "#loginPanel")}>Forgot password?</a>
										</div>
									</div>
								</div>
								<div className="login-right" id="forgotPanel" style={{ display: 'none' }}>
									<h2>Forgot <span>Password</span></h2>
									<div className="frgt-pwd">
										<div className="frm-control">
											<input type="text" maxLength="255" name="authemail" ref="authemail" placeholder="Username" onKeyPress={(e) => this._handleKeyEnterPress(e)} />
											<label className="user-ico"></label>
										</div>
										<div style={{ clear: "both" }}></div>
										<input type="button" name="submit" value="Request Password" title="Request Password" className="mail-icon" onClick={() => this.userForgotPassword()} />
										&nbsp; <a href="javascript:void(0);" onClick={() => Common.showHide("#loginPanel", "#forgotPanel")}>Login</a> </div>
								</div>
							</div>
						</div>
					</div>
				}
				{
					User.isLoggedIn() &&
					<div className="login-section">
						<div className="row">
							<div style={{ background: '#14a430 none repeat scroll 0 0', borderTop: '5px solid #14a430', padding: '18px', position: 'absolute', right: '63px', top: '85px', width: '420px' }}>
								<a style={{ color: 'white', fontSize: '18px', fontWeight: 'bold' }} title="Go to learning room" href="#/learningroom">Go to learning room --></a>
							</div>
						</div>
					</div>
				}
				<div className="social-ban">
					<ul>
						<li><a href="https://www.facebook.com/361dm" title="Facebook" target="_blank" rel="noopener noreferrer">
							<img src={process.env.PUBLIC_URL + '/images/fb-ico.jpg'} alt="Facebook" width="45" height="43" /></a></li>
						<li><a href="https://plus.google.com/s/361DM/top" title="Google+" target="_blank" rel="noopener noreferrer">
							<img src={process.env.PUBLIC_URL + '/images/gplus-ico.jpg'} alt="Google+" width="45" height="45" /></a></li>
						<li><a href="https://twitter.com/361dm" title="Twitter" target="_blank" rel="noopener noreferrer">
							<img src={process.env.PUBLIC_URL + '/images/tw-ico.jpg'} alt="Twitter" width="45" height="42" /></a></li>
						<li><a href="https://www.linkedin.com/company/361-degree-minds?" target="_blank" rel="noopener noreferrer" title="Linkedin">
							<img src={process.env.PUBLIC_URL + '/images/in-ico.jpg'} alt="Linkedin" width="45" height="46" /></a></li>
					</ul>
				</div>
			</section>
		</div>);
	}
}



// WEBPACK FOOTER //
// ./src/partials/HomeHeader.js